import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anc-settings',
  templateUrl: './anc-settings.component.html',
  styleUrls: ['./anc-settings.component.css']
})
export class AncSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
